export { default } from './SmileAssessmentForm';
